import { render } from "./RecipeStats.vue?vue&type=template&id=34ac8070&scoped=true"
import script from "./RecipeStats.vue?vue&type=script&lang=js"
export * from "./RecipeStats.vue?vue&type=script&lang=js"

import "./RecipeStats.vue?vue&type=style&index=0&id=34ac8070&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ac8070"]])

export default __exports__